import { useState, useEffect } from "react";

interface TextFilePreviewProps {
  file: File;
}

export function TextFilePreview({ file }: TextFilePreviewProps) {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const readContent = async () => {
      try {
        setLoading(true);
        const reader = new FileReader();
        reader.onload = (e) => {
          setContent((e.target?.result as string) || "");
          setLoading(false);
        };
        reader.onerror = () => {
          setContent("无法读取文件内容");
          setLoading(false);
        };
        reader.readAsText(file);
      } catch (error) {
        setContent("读取文件时出错");
        setLoading(false);
      }
    };

    readContent();
  }, [file]);

  return (
    <div className="w-full h-full">
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <p>加载中...</p>
        </div>
      ) : (
        <pre className="w-full h-full overflow-auto p-4 bg-gray-100 text-sm text-gray-900 whitespace-pre-wrap">
          {content}
        </pre>
      )}
    </div>
  );
}
